import i18n from "@/i18n";

// Homepage templates
const defaultHomepage = require(`../assets/images/template_previews/default.png`);
const blogsGreenHomepage = require(`../assets/images/template_previews/blogs_green.png`);
const blogsPurpleHomepage = require(`../assets/images/template_previews/blogs_purple.png`);

export const dataImageSizes = {
  xs: "300w",
  sm: "480w",
  md: "768w",
  lg: "1024w",
};

export const ROLE_ADMIN = {
  value: "ROLE_ADMIN",
  title: "Administrator",
  title_shorthand: "Admin",
  icon: "mdi-shield-account-variant",
  disclaimer: i18n.t("settings.workplace_users_invite_role_admin_disclaimer"),
};

export const ROLE_EDITOR = {
  value: "ROLE_EDITOR",
  title: "Editor",
  title_shorthand: "Editor",
  icon: "mdi-pencil",
  disclaimer: i18n.t("settings.workplace_users_invite_role_editor_disclaimer"),
};

export const ROLE_OWNER = {
  value: "ROLE_OWNER",
  title: "Owner",
  title_shorthand: "Owner",
  icon: "mdi-account-key",
};

export const ROLE_SUPPORT = {
  value: "ROLE_SUPPORT",
};

export const USER_ROLES = [ROLE_ADMIN, ROLE_EDITOR, ROLE_OWNER];

// TODO: Might be useful later
export const USER_ROLE_FALLBACK = {
  icon: "mdi-tag",
  information: "This field is for explanation of the role (could be stored in some info about roles)",
};

export const LIVE_CHAT_DEFAULT_QUESTIONS = [
  { text: "Enter your ZIP code", value: "zip" },
  { text: "Who is your current insurer?", value: "current_insurer" },
  { text: "Do you want to insure multiple vehicles?", value: "multiple_vehicles" },
  { text: "Which age group are you in?", value: "age_group" },
  { text: "Do you own your home?", value: "home_ownership" },
  { text: "Do you have a DUI?", value: "dui" },
  { text: "How long have you been continuously insured?", value: "continuously_insured" },
  { text: "How many incidents have you had in the last 12 months?", value: "incidents" },
  { text: "Do you need an SR-22 form?", value: "sr_22_form" },
  { text: "Are you insured?", value: "is_insured" },
];
export const HEADERS_TEMPLATES_UPDATES_DATE = "2023-07-06T07:59:29+00:00";
export const HEADER_TEMPLATES = [
  { text: "Logo left + Content", value: "logo_left_content" },
  { text: "Logo center + Content", value: "logo_center_content" },
  { text: "Blogs", value: "blogs" },
  { text: "Blogs Green", value: "blogs_green" },
];
export const HEADER_TEMPLATES_OLD = [
  { text: "Default (Old)", value: "default" },
  { text: "Mobile Burger (Old)", value: "mobile_burger" },
  { text: "Centred logo (Old)", value: "centred_logo" },
];

export const HEADER_MOBILE_TEMPLATES = [
  { text: "Logo left + Content", value: "logo_left_content" },
  { text: "Logo center + Content", value: "logo_center_content" },
  { text: "Logo left + Menu burger icon", value: "logo_left_burger" },
  { text: "Logo center", value: "logo_center" },
];

export const HEADER_LOGO_POSITIONS = [
  { text: "Left (Old)", value: 1 },
  { text: "Center (Old)", value: 2 },
];
export const AB_REDIRECT_TYPES = {
  REPLACE: "replace",
  HREF: "href",
};

export const AB_POOL_TYPES = {
  GENERAL: "general",
  STATE: "state",
};
export const AB_SPLIT_TYPES = {
  CUSTOM: "custom",
  EVEN: "even",
};
export const AB_REDIRECT_METHODS = [
  { text: "Non-History Redirect", value: AB_REDIRECT_TYPES.REPLACE },
  { text: "History Redirect", value: AB_REDIRECT_TYPES.HREF },
];
export const FOOTER_TEMPLATES = [
  { text: "Default", value: "default" },
  { text: "Blogs", value: "blogs" },
  { text: "Blogs purple", value: "blogs_purple" },
  { text: "Blogs green", value: "blogs_green" },
  { text: "Audio forms", value: "audio_forms" },
];

export const FOOTER_MENU_POSITIONS = [
  { text: "Left", value: 1 },
  { text: "Center", value: 2 },
];

export const FOOTER_MENU_ITEM_FONT_SIZES = [
  { text: "8px", value: "8px" },
  { text: "9px", value: "9px" },
  { text: "10px", value: "10px" },
  { text: "11px", value: "11px" },
  { text: "12px", value: "12px" },
  { text: "13px", value: "13px" },
  { text: "14px", value: "14px" },
  { text: "15px", value: "15px" },
  { text: "16px", value: "16px" },
  { text: "17px", value: "17px" },
  { text: "18px", value: "18px" },
  { text: "19px", value: "19px" },
  { text: "20px", value: "20px" },
  { text: "21px", value: "21px" },
  { text: "22px", value: "22px" },
  { text: "23px", value: "23px" },
  { text: "24px", value: "24px" },
  { text: "25px", value: "25px" },
  { text: "26px", value: "26px" },
];

export const FOOTER_LOGO_POSITIONS = [
  { text: "Left", value: 1 },
  { text: "Center", value: 2 },
  { text: "Right", value: 3 },
];

export const DOMAIN_STATUS = {
  CONNECTED: "connected",
  CONNECTING: "connecting",
  ERROR: "error",
};

export const DOMAIN_DEPLOYMENT_STATUS = [
  { status: DOMAIN_STATUS.CONNECTING, label: "Configuring...", chipColor: "" },
  { status: DOMAIN_STATUS.CONNECTED, label: "Connected", chipColor: "success" },
  { status: DOMAIN_STATUS.ERROR, label: "Error", chipColor: "error" },
];

export const DOMAIN_TYPE = {
  PROVIDED: "provided",
  CUSTOM: "custom",
};

export const ROBOTS = {
  allow: "User-agent: *\nAllow: /",
  disallow: "User-agent: *\nDisallow: /",
};

export const BLOGS_TEMPLATES = [
  {
    label: "Default",
    value: "default",
    image: defaultHomepage,
  },
  {
    label: "Blogs green",
    value: "blogs_green",
    image: blogsGreenHomepage,
  },
  {
    label: "Blogs purple",
    value: "blogs_purple",
    image: blogsPurpleHomepage,
  },
];

export const PAGE_TYPES = [
  { text: "Lander", value: 1 },
  { text: "Article", value: 2 },
  { text: "Audio form", value: 3 },
  { text: "Legal", value: 4 },
];

export const ADVANCED_CONTENT_SEARCH = [
  {
    value: "",
    text: i18n.t("resources.pages.content_search_filters.basic_search"),
  },
  {
    value: "content",
    text: i18n.t("resources.pages.content_search_filters.advanced_search"),
  },
  {
    value: "encoded_content",
    text: i18n.t("resources.pages.content_search_filters.encoded_content_search"),
  },
];

export const TOAST_INITIAL_TIME = "10000";

export const PAGE_STATUSES = [
  { text: "Draft", value: 1, chipColor: null, tooltipText: i18n.t("resources.pages.draft_tooltip") },
  { text: "Published", value: 2, chipColor: "success", tooltipText: i18n.t("resources.pages.published_tooltip") },
  { text: "Archived", value: 3, chipColor: "archived" },
];
export const SUCCESS_FILTERS = [
  { text: "Success", value: true },
  { text: "Failure", value: false },
];
export const RINGBA_FILTERS = [
  {
    label: "Phone number",
    options: [{ text: "No number", value: "no_number" }],
  },
  {
    label: "RINGBA CODE/TAG",
    options: [
      { text: "No code", value: "no_script" },
      { text: "Script", value: "script" },
      { text: "Wrapper", value: "worker" },
    ],
  },
];

export const MENU_ITEM_TYPES = [
  { text: "Page", value: 1 },
  { text: "Link", value: 2 },
  { text: "Page Category", value: 3 },
];

export const FEATURED_CATEGORIES_ITEM_TYPES = [
  { text: "Link", value: "link" },
  { text: "Page Category", value: "page_category" },
];

export const MENU_TAB_TYPES = [
  { text: "Same tab", value: "same_tab" },
  { text: "New tab", value: "new_tab" },
];

export const MODAL_DISPLAY_TYPES = [
  { text: "Inactivity (after 20s)", value: 1 },
  { text: "Scroll", value: 2 },
  { text: "Exit", value: 3 },
];

export const USER_STATUSES = {
  REGISTERED: "registered",
  PARTIALLY_REGISTERED: "partially_registered",
};

export const USER_DELETE_CONFIRMATION_WORD = "DELETE";

export const ORGANIZATION_DELETE_CONFIRMATION_WORD = "DELETE";

export const LIST_ITEMS_PER_PAGE = [5, 10, 15, 20, 50];

/**
 * Price in $ monthy
 */
export const PAYMENT_PLANS = {
  BASIC: {
    name: "Basic",
    code: "SR-BASIC",
    price: 7.95,
    teammatesLimit: 1,
    formattedTeammatesLimit: "1",
    domainsLimit: 1,
    formattedDomainsLimit: "1",
    uniqueBenefit: "1-on-1 onboarding call",
    additionalChip: {
      text: "Personalized offer",
      textColor: "#FF8A00",
      color: "#ffb4001c",
    },
  },
  STANDARD: {
    name: "Standard",
    code: "SR-STANDARD",
    price: 49,
    teammatesLimit: 1,
    formattedTeammatesLimit: "1",
    domainsLimit: 1,
    formattedDomainsLimit: "1",
    uniqueBenefit: "Customer support (email, chat)",
  },
  PRO: {
    name: "Pro",
    code: "SR-PRO",
    price: 99,
    teammatesLimit: 3,
    formattedTeammatesLimit: "3",
    domainsLimit: 10,
    formattedDomainsLimit: "10",
    uniqueBenefit: "24/7 priority tech support",
  },
  AGENCY: {
    name: "Agency",
    code: "SR-AGENCY",
    price: 299,
    teammatesLimit: 9999,
    formattedTeammatesLimit: "Unlimited",
    domainsLimit: 9999,
    formattedDomainsLimit: "Unlimited",
    uniqueBenefit: "24/7 priority tech support",
  },
};

export const PAYMENT_DISCOUNTS = {
  // TODO: update discounts once/if we enable marketing pages
  // STANDARD_30: {
  //   discountLabel: "30% OFF",
  //   // Amount in $, not percentage. Subtracted from the Plan.price
  //   discountAmount: 50,
  //   appliesTo: [PAYMENT_PLANS.STANDARD.name],
  //   couponCode: "STANDARD30",
  // },
};

export const SUBSCRIPTION_STATUS = {
  INCOMPLETE: "incomplete",
  INCOMPLETE_EXPIRED: "incomplete_expired",
  TRIALING: "trialing",
  ACTIVE: "active",
  PAST_DUE: "past_due",
  CANCELED: "canceled",
  UNPAID: "unpaid",
  PAUSED: "paused",
  EARLY_ACCESS: "early_access",
};

export const INVOICE_STATUS = {
  DRAFT: "draft",
  OPEN: "open",
  PAID: "paid",
  UNCOLLECTIBLE: "uncollectible",
  VOID: "void",
};

export const MAIN_DOMAIN_URL = process.env.VUE_APP_PAGES_DOMAIN;

export const REGISTRAR_LIST = [
  {
    name: "NameCheap",
    value: "nameCheap",
    helpLink: "https://help.siterunner.com/help/domains-how-to-set-up-the-cname-records-for-namecheap",
  },
  {
    name: "Google Domains (SquareSpace)",
    value: "googleDomains",
    helpLink: "https://help.siterunner.com/help/domains-cname-records-for-google-domains-now-squarespace",
  },
  {
    name: "GoDaddy",
    value: "goDaddy",
    helpLink: "https://help.siterunner.com/help/domains-how-to-set-up-the-cname-records-for-godaddy",
  },
  {
    name: "BlueHost",
    value: "blueHost",
    helpLink: "https://help.siterunner.com/help/domains-how-to-set-up-the-cname-records-for-dreamhost",
  },
  {
    name: "DreamHost",
    value: "dreamHost",
    helpLink: "https://help.siterunner.com/help/domains-how-to-set-up-the-cname-records-for-dreamhost",
  },
  {
    name: "Other",
    value: "other",
    helpLink: "https://help.siterunner.com/help/search?keyword=cname",
  },
];

export const AB_SCRIPT = id => {
  return `<script>(()=>{const t="${id}",e="opacity: 0 !important; background: none !important;",r=document.documentElement.style;r.cssText+=e;const n=document.createElement("script");n.src=\`https://progress.siterunner.com/app.js?id=\${t}\${(()=>{try{const e=JSON.parse(localStorage.getItem("siterunner-progress"))[t];return void 0===e.e||Date.now()>e.e||void 0===e.t?"":\`&p=\${window.btoa(e.t)}\`}catch{return""}})()}\`,n.type="text/javascript",n.onerror=()=>{r.cssText=r.cssText.replace(e,"")},n.fetchPriority="high",document.head.prepend(n)})();</script>`;
};

export const GTM_FILTERS = [
  { text: "Added", value: "true" },
  { text: "Not added", value: "false" },
];

export const JOURNAYA_FILTERS = [
  { text: "Added", value: "true" },
  { text: "Not added", value: "false" },
];

export const LEADSPEDIA_FILTERS = [
  { text: "Added", value: "true" },
  { text: "Not added", value: "false" },
];

export const FORM_TYPE_FILTERS = [
  { text: "Auto", value: "auto" },
  { text: "Health", value: "health" },
  { text: "Med", value: "med" },
  { text: "Solar", value: "solar" },
];

export const AB_TEST_STATUSES = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  DRAFT: "draft",
};

export const AB_TEST_UNKNOWN_DATA = "Unknown";

export const AB_TEST_STATISTICS_OPTIONS = {
  SUMMARY: "summary",
  DAILY: "daily",
};

export const PAGE_HISTORY_STATUS = {
  UNKNOWN: "Unknown",
};

export const PAGE_UPLOAD_STATUSES = {
  SUCCESS: "Success",
  ERROR: "Error",
  PENDING: "Pending",
};

export const PHONE_NUMBER_STATUSES = {
  GENERATING: "generating",
  ACTIVE: "active",
  ERROR: "error",
};

export const PHONE_NUMBER = {
  campaignId: "",
  publisherSubId: "",
  publisherName: "",
  numberPoolId: "",
  domain: "",
};
